import React from 'react'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Grow from '@material-ui/core/Grow'
import Paper from '@material-ui/core/Paper'
import Popper from '@material-ui/core/Popper'
import MenuList from '@material-ui/core/MenuList'
import './BurgerMenu.scss'
import { MobileNavDropdown } from './MobileNavDropdown'

class BurgerMenu extends React.Component {
  render() {
    const { open, anchorEl, handleClose } = this.props

    return (
      <div style={{ display: 'flex' }}>
        <div>
          <Popper
            className="mobile-popper"
            open={open}
            anchorEl={anchorEl}
            transition
            disablePortal
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                id="menu-list-grow"
                style={{
                  transformOrigin:
                    placement === 'bottom' ? 'center top' : 'center bottom',
                }}
              >
                <Paper square>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList style={{ padding: 0 }}>
                      <MobileNavDropdown />
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </div>
    )
  }
}

export default BurgerMenu
